import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const styles = {
  searchContainer: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 1,
  },
  searchField: {
    minWidth: "250px",
    "& .MuiInputBase-root": {
      backgroundColor: "white",
    },
  },
};

export default function SearchField({
  value,
  onChange,
  placeholder = "Search fields",
  ...props
}) {
  const handleChange = event => {
    onChange(event.target.value);
  };

  return (
    <Box sx={styles.searchContainer}>
      <TextField
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        sx={styles.searchField}
        InputProps={{
          endAdornment: (
            <>
              <InputAdornment position="end">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            </>
          ),
        }}
        {...props}
      />
    </Box>
  );
}
